import { FunctionComponent, HTMLAttributes, useContext } from 'react';
import styled from 'styled-components';

import { BlockContext } from '@context/blocks';
import { Page } from '@typings/page';
import { getPageBlocks } from '@utilities/block';

import { PagesDragItem } from './pages-drag-item';
import { PagesDropItem } from './pages-drop-item';
import { PagesDropzone } from './pages-dropzone';

interface PagesListItemProps extends HTMLAttributes<HTMLLIElement> {
  page: Page;
}

const UnstyledPagesListItem: FunctionComponent<PagesListItemProps> = (props) => {
  const { page, ...otherProps } = props;

  const { sections } = useContext(BlockContext);

  const sectionBlocks = getPageBlocks(sections, page.key);

  return (
    <li {...otherProps}>
      <PagesDropzone page={page}>
        <PagesDropItem page={page}>
          <PagesDragItem page={page}>
            {sectionBlocks.length > 0 && (
              <PagesDropzone pageKey={page.key}>
                {sectionBlocks.map((block, index) => {
                  const { createdAt, deletedAt, position, updatedAt } = block;
                  if (deletedAt) return null;
                  // this key forces re-render on drag, drop, and save
                  const key = `${block.key}-${createdAt}-${updatedAt}-${position}-${index}`;
                  return (
                    <PagesDropItem block={block} key={key}>
                      <PagesDragItem block={block} sectionBlocks={sectionBlocks} />
                    </PagesDropItem>
                  );
                })}
              </PagesDropzone>
            )}
          </PagesDragItem>
        </PagesDropItem>
      </PagesDropzone>
    </li>
  );
};

const StyledPagesListItem = styled(UnstyledPagesListItem)`
  margin-bottom: 8px;

  &:last-child {
    margin-bottom: 0;
  }

  .bf-button__icon {
    height: 32px;
    margin-right: 5px;
    min-height: 0;
    padding: 9px;
    width: 32px;

    .bf-icon__font {
      font-size: 12px;
    }

    &:last-child {
      margin-right: 0;
    }
  }
`;

export const PagesListItem: FunctionComponent<PagesListItemProps> = (props) => {
  return <StyledPagesListItem {...props} />;
};
